import React from 'react';
import ReactDOM from 'react-dom';
import registerServiceWorker from './registerServiceWorker';
import App from "./components/app";
import './less/app.less';
import Preloader from "./components/preloader";

ReactDOM.render(<Preloader><App/></Preloader>, document.getElementById('root'));
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js